import React, { useState, useRef, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { setI18nLanguage } from '../../i18n/config';
import i18n from '../../i18n/config';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  const { t } = useTranslation('login');

  // ---- Language menu state ----
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const langMenuRef = useRef(null);

  // Close the language menu on outside click.
  useEffect(() => {
    if (!langMenuOpen) return;
    const handleClickOutside = (e) => {
      if (langMenuRef.current && !langMenuRef.current.contains(e.target)) {
        setLangMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [langMenuOpen]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 relative">

      {/* ---- LANGUAGE TOGGLE ---- */}
      <div ref={langMenuRef} className="absolute top-4 right-4">
        <button
          onClick={() => setLangMenuOpen((open) => !open)}
          aria-label="Language menu"
          aria-expanded={langMenuOpen}
          className="text-xs font-medium text-gray-600 border border-gray-200 rounded-lg px-2.5 py-1.5 hover:bg-gray-50 transition bg-white"
        >
          {i18n.language === 'ml' ? 'മലയാളം' : 'EN'}
        </button>
        {langMenuOpen && (
          <div className="absolute right-0 top-10 w-32 bg-white rounded-xl shadow-lg border border-gray-100 p-2 z-50">
            <button
              onClick={() => {
                const lang = 'en';
                setI18nLanguage(lang);
                localStorage.setItem('zbookkeeping_language', lang);
                setLangMenuOpen(false);
              }}
              className={`w-full text-left rounded-lg px-3 py-2 text-sm transition ${
                i18n.language === 'en' ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              English
            </button>
            <button
              onClick={() => {
                const lang = 'ml';
                setI18nLanguage(lang);
                localStorage.setItem('zbookkeeping_language', lang);
                setLangMenuOpen(false);
              }}
              className={`w-full text-left rounded-lg px-3 py-2 text-sm transition ${
                i18n.language === 'ml' ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              മലയാളം
            </button>
          </div>
        )}
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-10 w-full max-w-xs flex flex-col items-center">

        {/* NGO Logo */}
        <img
          src="https://i.postimg.cc/2jPTkT7T/z-bookkeeping.png"
          alt="z.Bookkeeping logo"
          className="w-24 h-24 object-contain mb-4"
        />

        {/* App name */}
        <h1 className="text-lg font-medium text-gray-900 mb-1">{t('title')}</h1>
        <p className="text-xs text-gray-500 text-center mb-8 uppercase tracking-widest">
          {t('tagline')}
        </p>

        {/* Login button */}
        <button
          onClick={() => loginWithRedirect()}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-3 text-sm font-medium transition"
        >
          {t('login')}
        </button>

      </div>
    </div>
  );
};

export default Login;